import {useSequenceValidation} from '@/modules/patients-therapies/hooks'
import {Box, Button, ButtonGroup, Text} from '@chakra-ui/react'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {useTranslate} from '@tolgee/react'

// Panel for prescriptions awaiting the optional budget/admin sign-off before the
// doctor flow starts: approve moves it to the doctor validation, reject sends
// it to the final budget_not_approved state.
export function AdminValidation({sequence}: {sequence: PatientTherapySequence}) {
  const {t: tActivity} = useTranslate('activity')
  const {canApproveBudget, canRejectBudget, onApproveBudget, onRejectBudget} = useSequenceValidation(sequence)

  const canManageBudget = canApproveBudget || canRejectBudget

  return (
    <Box width="100%">
      <Box width="100%">
        <Box
          display="flex"
          flexDirection="column"
          width={'100%'}
          alignItems={{base: 'center', md: 'flex-start'}}
          justifyContent={{base: 'center', md: 'flex-start'}}
        >
          <Text fontSize="sm" fontWeight="medium">
            {tActivity('pending_approval.title')}
          </Text>
          <Text display={{base: 'none', md: 'inline-flex'}} color="fg.muted">
            {tActivity('pending_approval.description')}
          </Text>
        </Box>

        {canManageBudget ? (
          <ButtonGroup mt="2" display="flex" flexDirection="column" gap="2" size="md" width="100%">
            {canApproveBudget && (
              <Button variant="subtle" colorPalette="cyan" width="100%" onClick={onApproveBudget}>
                {tActivity('actions.APPROVE_BUDGET')}
              </Button>
            )}
            {canRejectBudget && (
              <Button variant="subtle" colorPalette="red" width="100%" onClick={onRejectBudget}>
                {tActivity('actions.REJECT_BUDGET')}
              </Button>
            )}
          </ButtonGroup>
        ) : (
          <Text color="fg.muted">{tActivity('pending_approval.admin_required')}</Text>
        )}
      </Box>
    </Box>
  )
}
